// extracted by mini-css-extract-plugin
export default {"recommended":"NeBNz"};